<template>
  <div id="app">
    <div class="w-full px-2 py-2">
      <div class="my-2">
        <span>
          <!-- BEGIN: Content -->
          <div>
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-body px-8 py-6">
                  <span class="inline-flex justify-center mx-2">
                    <router-link :to="{ path: '/boat-detail/' + this.$route.params.id }">
                      <div class="
                          inline-block
                          gap-1
                          border border-1 border-black
                          rounded
                        ">
                        <ArrowLeftIcon />
                      </div>
                      <span class="inline-block mx-2 align-top mt-1">Boat Detail</span>
                    </router-link>
                  </span>
                  <h2 class="text-xl font-semibold px-2 py-2">
                    Add New Repair
                  </h2>
                  <div v-if="role == 'Athlete'" class="p-10">
                    <div class="flex justify-center">
                      <AlertCircleIcon class="w-8 h-8 my-4" />
                    </div>
                    <div class="flex justify-center text-center">
                      You do not have permission to view this page
                    </div>
                  </div>
                  <div v-if="isAvailable">
                    <div class="px-4">
                      <label for="crud-form-1" class="form-label">Cost</label>
                      <input v-model="validate.cost.$model" id="crud-form-1" type="text" class="form-control w-full"
                        required />
                    </div>
                    <div class="px-4 mt-2">
                      <label for="crud-form-1" class="form-label">Note</label>
                      <input v-model="validate.note.$model" id="crud-form-1" type="text" class="form-control w-full" />
                    </div>
                  </div>
                </div>
                <div role="button" class="text-right p-4" @click="disable()" v-if="isAvailable">
                  <button @click="addRepair()" id="submit" class="btn btn-primary w-24">
                    Save
                    <LoadingIcon v-if="loading.value" icon="oval" class="w-4 h-4 ml-4 text-white" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- END: Large Modal Content -->
        </span>
        <!-- BEGIN: Failed Notification Content -->
        <div id="failed-notification-content" class="toastify-content hidden flex">
          <XCircleIcon class="text-theme-6" />
          <div class="ml-4 mr-4">
            <div class="font-medium">Please fill all requirements</div>
            <div class="text-gray-600 mt-1">Please check the form.</div>
          </div>
        </div>
        <!-- END: Failed Notification Content -->
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, reactive, toRefs } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from '@/store'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Toastify from 'toastify-js'

export default {
  name: 'add repair',
  methods: {
    disable() {
      if (
        this.formData.cost !== '' &&
        this.formData.note !== ''
      ) {
        this.loading.value = true
        document.getElementById('submit').disabled = true
      }
    }
  },
  watch: {
    isSuccess() {
      if (this.isSuccess) {
        this.loading.value = true
        this.$router.back()
      } else {
        this.loading.value = false
        document.getElementById('submit').disabled = false
      }
    }
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    var loading = reactive({ value: false })
    const role = computed(() => store.state.profile.user?.userRole?.name)
    const isAvailable = computed(() => (store.state.profile.user?.userRole?.name == 'Coach' || store.state.profile.user?.userRole?.name == 'Super Admin'))
    const isSuccess = computed(
      () => store.state.inventories.addRepair.isSuccess
    )
    onMounted(() => { })
    const formData = reactive({
      id: route.params.id,
      cost: '',
      note: ''
    })
    const rules = {
      cost: {
        required
      },
      note: {
        required
      }
    }
    const validate = useVuelidate(rules, toRefs(formData))
    const addRepair = () => {
      validate.value.$touch()
      if (validate.value.$invalid) {
        Toastify({
          node: cash('#failed-notification-content')
            .clone()
            .removeClass('hidden')[0],
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
      } else {
        store.dispatch('inventories/addRepair', formData)
      }
    }
    return {
      formData,
      validate,
      loading,
      isSuccess,
      role,
      isAvailable,
      addRepair
    }
  }
}
</script>
